












































































import Vue from 'vue';
import VueSlider from 'vue-slider-component';
import {budgetPreferences} from '@/store/modules/itinerary-preferences/itinerary-preferences-types';
import 'vue-slider-component/theme/default.css';

class GoalBudgetMapper {
  static labels = {
    LOW: 'Lowest Prices',
    MID: 'Mid Range',
    BEST: 'Best Experience',
    LUXURY: 'Luxury',
  };

  static values = {
    [GoalBudgetMapper.labels.LOW]: 0,
    [GoalBudgetMapper.labels.MID]: 33.3,
    [GoalBudgetMapper.labels.BEST]: 66.6,
    [GoalBudgetMapper.labels.LUXURY]: 100,
  };

  static valueToLabel(value: number): string {
    if (value < this.values[GoalBudgetMapper.labels.MID]) {
      return GoalBudgetMapper.labels.LOW;
    } else if (value < this.values[GoalBudgetMapper.labels.BEST]) {
      return GoalBudgetMapper.labels.MID;
    } else if (value < this.values[GoalBudgetMapper.labels.LUXURY]) {
      return GoalBudgetMapper.labels.BEST;
    } else {
      return GoalBudgetMapper.labels.LUXURY;
    }
  }

  static labelToValue(label: string): number {
    return GoalBudgetMapper.values[label] || GoalBudgetMapper.values[GoalBudgetMapper.labels.LOW];
  }

  static marks = {
    [GoalBudgetMapper.values[GoalBudgetMapper.labels.LOW]]: {
      label: 'Lowest Prices',
      labelStyle: {
        transform: 'translateX(0)',
      },
    },
    [GoalBudgetMapper.values[GoalBudgetMapper.labels.MID]]: 'Mid Range',
    [GoalBudgetMapper.values[GoalBudgetMapper.labels.BEST]]: 'Best Experience',
    [GoalBudgetMapper.values[GoalBudgetMapper.labels.LUXURY]]: {
      label: 'Luxury',
      labelStyle: {
        transform: 'translateX(-32px)',
      },
    },
  };
}

class StayBudgetMapper {
  static labels = {
    R_0_100: '< $100',
    R_100_200: '$100-200',
    R_200_400: '$200-400',
    R_400_800: '$400-800',
    R_800_PLUS: '> $800',
  };

  static values = {
    [StayBudgetMapper.labels.R_0_100]: [0, 25],
    [StayBudgetMapper.labels.R_100_200]: [25, 55],
    [StayBudgetMapper.labels.R_200_400]: [50, 75],
    [StayBudgetMapper.labels.R_400_800]: [75, 100],
    [StayBudgetMapper.labels.R_800_PLUS]: [100, 100],
  };

  static valueToLabel(value: number[]): string {
    const maxVal = value[1];
    if (maxVal <= StayBudgetMapper.values[StayBudgetMapper.labels.R_0_100][1]) {
      return StayBudgetMapper.labels.R_0_100;
    } else if (maxVal <= StayBudgetMapper.values[StayBudgetMapper.labels.R_100_200][1]) {
      return StayBudgetMapper.labels.R_100_200;
    } else if (maxVal <= StayBudgetMapper.values[StayBudgetMapper.labels.R_200_400][1]) {
      return StayBudgetMapper.labels.R_200_400;
    } else if (maxVal <= StayBudgetMapper.values[StayBudgetMapper.labels.R_400_800][1]) {
      return StayBudgetMapper.labels.R_400_800;
    } else {
      return StayBudgetMapper.labels.R_800_PLUS;
    }
  }

  static labelToValue(label: string): number[] {
    return StayBudgetMapper.values[label] || StayBudgetMapper.values[StayBudgetMapper.labels.R_0_100];
  }

  static marks = {
    '0': {
      label: StayBudgetMapper.labels.R_0_100,
      labelStyle: {
        transform: 'translateX(0)',
      },
    },
    '25': StayBudgetMapper.labels.R_100_200,
    '50': StayBudgetMapper.labels.R_200_400,
    '75': StayBudgetMapper.labels.R_400_800,
    '100': {
      label: StayBudgetMapper.labels.R_800_PLUS,
      labelStyle: {
        transform: 'translateX(-32px)',
      },
    },
  };
}

export default Vue.extend({
  name: 'ItineraryPreferencesBudget',
  components: {VueSlider},
  props: {
    value: {
      type: Object,
      default: () => budgetPreferences,
    },
  },
  computed: {
    goalBudgetValue(): number {
      return this.currentValue.price_tolerance * 100;
    },
    nightlyStayBudgetValue(): number {
      return this.currentValue.stay_budget_per_day[0] * 100;
    },
    experienceBudgetValue(): number {
      return this.currentValue.experience_budget_per_day[0] * 100;
    },
  },
  data: function() {
    return {
      currentValue: this.value,
      budgetMarks: GoalBudgetMapper.marks,
      nightlyStayBudgetMarks: StayBudgetMapper.marks,
      experiencesBudgetMarks: StayBudgetMapper.marks,
    };
  },
  methods: {
    handleChangeBudgetGoal(value: number) {
      this.currentValue.price_tolerance = value / 100;
    },

    handleChangeStayBudget(value: number) {
      this.currentValue.stay_budget_per_day = [value / 100, value / 100];
    },

    handleChangeExperiencesBudget(value: number) {
      this.currentValue.experience_budget_per_day = [value / 100, value / 100];
    },

    handleDragEnd() {
      this.$emit('preferences-change', this.currentValue, 'budgetPreferences');
    },
  },
});
